import { render, staticRenderFns } from "./BankBranchModal.vue?vue&type=template&id=559dce5a&scoped=true"
import script from "./BankBranchModal.vue?vue&type=script&lang=js"
export * from "./BankBranchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559dce5a",
  null
  
)

export default component.exports